


export default {
	// name: 'rest-model',

	// functional: true,

	props:
	{
		debugStr: {
			type: String,
			default: ''
		},

		editable:
		{
			type: Boolean,
			default: false
		},

		url:
		{
			type: String,
			default: ''
		},

		field:
		{
			type: String,
			default: ''
		},

		modelId:
		{
			type: Number,
			default: -1,
		},

		tag:
		{
			type: String,
			default: 'span'
		},

		allLocales:
		{
			type: Boolean,
			default: false,
		}
	},


	render(createElement)
	{
		// return this.$slots.default;
		return createElement(
			this.tag,
			{

			},
			this.$slots.default
		)
	},


}
